import { createStore } from 'vuex';
import axios from 'axios';
import api from '@/api/axios';

export default createStore({
    state: {
        token: localStorage.getItem('lunar-token') || null,
        user: JSON.parse(localStorage.getItem('ptr-user')) || null, // Load from localStorage
        isFullScreen: localStorage.getItem('isFullScreen') === 'true',

    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem('lunar-token', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        },
        SET_USER(state, user) {
            state.user = user;
            localStorage.setItem('ptr-user', JSON.stringify(user));
        },
        LOGOUT(state) {
            state.token = null;
            state.user = null;
            localStorage.removeItem('lunar-token');
            localStorage.removeItem('ptr-user');
            delete axios.defaults.headers.common['Authorization'];
        },
        SET_FULL_SCREEN(state, value) {
            state.isFullScreen = value
            localStorage.setItem('isFullScreen', value)
        }
    },
    actions: {
        async login({ commit }, credentials) {
            try {
                const response = await api.post('/login', credentials);
                commit('SET_TOKEN', response.data.token);
                commit('SET_USER', response.data.user);
                return true;
            } catch (error) {
                return false;
            }
        },
        async fetchUser({ commit, state }) {
            if (state.token) {
                try {
                    const response = await api.get('/user');
                    commit('SET_USER', response.data);
                } catch (error) {
                    commit('LOGOUT');
                }
            }
        },
        logout({ commit }) {
            commit('LOGOUT');
        },
        setFullScreen({ commit }, value) {
            console.log('Setting full screen');
            commit('SET_FULL_SCREEN', value)
        }
    },
    getters: {
        isAuthenticated: (state) => !!state.token,
        getUser: (state) => state.user,
        isFullScreen: (state) => state.isFullScreen,
        isAdmin: (state, getters) => {
            return getters.getUser?.role === 'admin';
        },
        isP: (state, getters) => {
            return getters.getUser?.role === 'practitioner';
        }
    },
});
